/** @format */

import React from "react";
import { Link, Tooltip, IconButton, Zoom } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// import Resume from "../../settings/resume.json";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getSocialLinks } from "../../action/notesActions";
import { getObject } from "../../utils/getName";

const useStyles = makeStyles((theme) => ({
  socialIcons: {
    position: "fixed",
    top: theme.spacing(6),
    right: theme.spacing(6),
  },
  iconButton: {
    height: "2.5rem",
    width: "2.5rem",
    display: "block",
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: "1.25rem",
  },
}));

export const SocialIcons = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const social = useSelector((state) => state.SocialLinks);
  const { socialLinks } = social;

  useEffect(() => {
    // get();
    dispatch(getSocialLinks());
  }, [dispatch]);

  console.log(socialLinks);

  return (
    <div className={classes.socialIcons}>
      {getObject(socialLinks, "email")?.status && (
        <Link
          href={`mailto:${
            getObject(socialLinks, "email")?.link
          }?subject=subject text`}
          key={"Google".toLowerCase()}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          color="inherit"
        >
          <Tooltip title={"Email"} placement="left" TransitionComponent={Zoom}>
            <IconButton
              color="inherit"
              aria-label="google"
              className={classes.iconButton}
            >
              <i className={`${classes.icon} fab fa-google`}></i>
            </IconButton>
          </Tooltip>
        </Link>
      )}

      {getObject(socialLinks, "linkedin")?.status && (
        <Link
          href={getObject(socialLinks, "linkedin")?.link}
          key={"LinkedIn".toLowerCase()}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          color="inherit"
        >
          <Tooltip
            title={"LinkedIn"}
            placement="left"
            TransitionComponent={Zoom}
          >
            <IconButton
              color="inherit"
              aria-label="LinkedIn"
              className={classes.iconButton}
            >
              <i className={`${classes.icon} fab fa-linkedin-in`}></i>
            </IconButton>
          </Tooltip>
        </Link>
      )}

      {getObject(socialLinks, "github")?.status && (
        <Link
          href={getObject(socialLinks, "github")?.link}
          key={"github".toLowerCase()}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          color="inherit"
        >
          <Tooltip title={"GitHub"} placement="left" TransitionComponent={Zoom}>
            <IconButton
              color="inherit"
              aria-label="github"
              className={classes.iconButton}
            >
              <i className={`${classes.icon} fab fa-github`}></i>
            </IconButton>
          </Tooltip>
        </Link>
      )}

      {getObject(socialLinks, "telegram")?.status && (
        <Link
          href={getObject(socialLinks, "telegram")?.link}
          key={"Telegram".toLowerCase()}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          color="inherit"
        >
          <Tooltip
            title={"Telegram"}
            placement="left"
            TransitionComponent={Zoom}
          >
            <IconButton
              color="inherit"
              aria-label="Telegram"
              className={classes.iconButton}
            >
              <i className={`${classes.icon} fab fa-telegram`}></i>
            </IconButton>
          </Tooltip>
        </Link>
      )}

      {getObject(socialLinks, "phone")?.status && (
        <Link
          href={`tel:${getObject(socialLinks, "phone")?.link}`}
          key={"phoneNo".toLowerCase()}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          color="inherit"
        >
          <Tooltip title={"Phone"} placement="left" TransitionComponent={Zoom}>
            <IconButton
              color="inherit"
              aria-label="phone"
              className={classes.iconButton}
            >
              {/* <i className={` fab fa-phone-slash`}></i> */}
              <i class={`${classes.icon} fas fa-phone`} aria-hidden="true"></i>
            </IconButton>
          </Tooltip>
        </Link>
      )}

      {getObject(socialLinks, "whatsApp")?.status && (
        <Link
          href={getObject(socialLinks, "whatsApp")?.link}
          key={"whatsApp".toLowerCase()}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          color="inherit"
        >
          <Tooltip
            title={"whatsApp"}
            placement="left"
            TransitionComponent={Zoom}
          >
            <IconButton
              color="inherit"
              aria-label="whatsApp"
              className={classes.iconButton}
            >
              <i className={`${classes.icon} fab fa-whatsapp`}></i>
            </IconButton>
          </Tooltip>
        </Link>
      )}

      {getObject(socialLinks, "web1")?.status && (
        <Link
          href={getObject(socialLinks, "web1")?.link}
          key={"Website".toLowerCase()}
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          color="inherit"
        >
          <Tooltip
            title={"Other Website"}
            placement="left"
            TransitionComponent={Zoom}
          >
            <IconButton
              color="inherit"
              aria-label="Website"
              className={classes.iconButton}
            >
              <i className={`${classes.icon} fa fa-globe`}></i>
            </IconButton>
          </Tooltip>
        </Link>
      )}
    </div>
  );
};
